'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LEVELS = exports.SIZES = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint-disable quote-props */


exports.default = Heading;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactProptypeConditionalRequire = require('react-proptype-conditional-require');

var _reactProptypeConditionalRequire2 = _interopRequireDefault(_reactProptypeConditionalRequire);

var _mergeProps = require('../../utils/mergeProps');

var _mergeProps2 = _interopRequireDefault(_mergeProps);

var _SpacerElement = require('../../internal/SpacerElement');

var _SpacerElement2 = _interopRequireDefault(_SpacerElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
  'heading': 'ccl-2a4b5924e2237093',
  'large': 'ccl-a1841d8ca69cee4a',
  'medium': 'ccl-9ff886da4b0592ae',
  'small': 'ccl-99c566dc40a8a156',
  'x-small': 'ccl-706ed5a06ead17d8',
  'black': 'ccl-21bead492ce4ada2',
  'white': 'ccl-29aecca02620e7cc'
};
var SIZES = exports.SIZES = ['large', 'medium', 'small', 'x-small'];
var LEVELS = exports.LEVELS = [1, 2, 3, 4];

/**
 * Exactly what it says on the tin: headings.
 */
function Heading(originalProps) {
  var isPlaceholder = originalProps.isPlaceholder;

  var props = isPlaceholder ? (0, _mergeProps2.default)(originalProps, Heading.placeholderProps) : originalProps;
  var element = 'h' + props.level;
  var classes = (0, _classnames2.default)(styles.heading, styles[props.color], styles[props.size || SIZES[props.level - 1]]);

  if (!props.children) {
    return null;
  }

  return _react2.default.createElement(
    _SpacerElement2.default,
    {
      element: element,
      spacing: props.spacing,
      className: classes,
      adjacentVerticalSpacing: props.adjacentVerticalSpacing,
      adjacentHorizontalSpacing: props.adjacentHorizontalSpacing,
      isPlaceholder: isPlaceholder
    },
    props.children
  );
}

Heading.displayName = 'Heading';
Heading.propTypes = _extends({
  /**
   * The level of the heading html tag to render (h1, h2 etc.).
   */
  level: (0, _reactProptypeConditionalRequire2.default)(_propTypes2.default.oneOf(LEVELS), function (props) {
    return !props.isPlaceholder;
  }),

  /**
   * The size of the title.
   */
  size: _propTypes2.default.oneOf(SIZES),

  /**
   * The heading colour
   */
  color: _propTypes2.default.oneOf(['black', 'white']),

  children: (0, _reactProptypeConditionalRequire2.default)(_propTypes2.default.node, function (props) {
    return !props.isPlaceholder;
  })

}, _SpacerElement2.default.propTypes);

Heading.defaultProps = _extends({
  color: 'black',
  size: null

}, _SpacerElement2.default.defaultProps);

Heading.placeholderProps = {
  level: 2,
  size: 'medium',
  children: 'heading'
};